import React from 'react';
import PropTypes from 'prop-types';

import { ChipsItem } from '@atlas/ui';

const ResultsTimeFilterItem = ({ isActive, onClick, subtitle, title }) => {
  return <ChipsItem active={isActive} label={title} onClick={onClick} sublabel={subtitle} />;
};

ResultsTimeFilterItem.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  subtitle: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default ResultsTimeFilterItem;
